// Mega Menu – Fix disappearing on scroll (Mouse Enter/Leave)
document.addEventListener('DOMContentLoaded', function () {
  const megaMenuItems = document.querySelectorAll('.has-megamenu');

  megaMenuItems.forEach(item => {
    // Mouse enter → open mega menu
    item.addEventListener('mouseenter', function () {
      this.classList.add('megamenu-open');
    });

    // Mouse leave → close mega menu
    item.addEventListener('mouseleave', function () {
      this.classList.remove('megamenu-open');
    });
  });
});
/*
 * CD Peacock
 * Hide Formilla chat while any ShapeDiver configurator is open.
 *
 * Works across:
 * - Product pages
 * - /cart
 * - Cart drawers
 * - Dynamically loaded Shopify sections
 * - Multiple customizable products on the same page
 */

(function () {
  "use strict";

  const ROOT_CLASS = "cdp-shapediver-configurator-open";

  /*
   * ShapeDiver controls.
   * The ID selectors are the confirmed selectors.
   * The additional selectors provide fallback coverage on cart pages
   * and future app markup changes.
   */
  const OPEN_SELECTORS = [
    "#app-builder-open-configurator",
    '[id="app-builder-open-configurator"]',
    '[data-testid="app-builder-open-configurator"]',
    '[data-action="open-configurator"]',
    '[class*="app-builder-open-configurator"]'
  ];

  const CLOSE_SELECTORS = [
    "#app-builder-modal-close-button",
    '[id="app-builder-modal-close-button"]',
    '[data-testid="app-builder-modal-close-button"]',
    '[data-action="close-configurator"]',
    '[class*="app-builder-modal-close-button"]'
  ];

  /*
   * Formilla can place the visible launcher inside different wrappers
   * or an iframe. These selectors cover the launcher and its containers.
   */
  const FORMILLA_SELECTORS = [
    "#formilla-chat-button-inner",
    "#formilla-chat-button",
    "#formilla-chat-button-container",
    "#formilla-chat-button-outer",
    '[id^="formilla-chat-button"]',
    '[id*="formilla-chat-button"]',
    '[class*="formilla-chat-button"]',
    'iframe[id*="formilla"]',
    'iframe[name*="formilla"]',
    'iframe[src*="formilla"]'
  ];

  const OPEN_SELECTOR = OPEN_SELECTORS.join(",");
  const CLOSE_SELECTOR = CLOSE_SELECTORS.join(",");
  const FORMILLA_SELECTOR = FORMILLA_SELECTORS.join(",");

  let configuratorOpen = false;
  let closeTimer = null;
  let observerQueued = false;

  /**
   * Add the CSS through JavaScript so only custom.js needs editing.
   */
  function installStyles() {
    if (document.getElementById("cdp-shapediver-formilla-styles")) {
      return;
    }

    const style = document.createElement("style");
    style.id = "cdp-shapediver-formilla-styles";

    style.textContent = `
      html.${ROOT_CLASS} #formilla-chat-button-inner,
      html.${ROOT_CLASS} #formilla-chat-button,
      html.${ROOT_CLASS} #formilla-chat-button-container,
      html.${ROOT_CLASS} #formilla-chat-button-outer,
      html.${ROOT_CLASS} [id^="formilla-chat-button"],
      html.${ROOT_CLASS} [id*="formilla-chat-button"],
      html.${ROOT_CLASS} [class*="formilla-chat-button"],
      html.${ROOT_CLASS} iframe[id*="formilla"],
      html.${ROOT_CLASS} iframe[name*="formilla"],
      html.${ROOT_CLASS} iframe[src*="formilla"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }
    `;

    (document.head || document.documentElement).appendChild(style);
  }

  /**
   * Direct inline styles are also applied because some Formilla
   * elements may have high-priority inline styling.
   */
  function forceHideFormilla() {
    document.querySelectorAll(FORMILLA_SELECTOR).forEach(function (element) {
      element.style.setProperty("display", "none", "important");
      element.style.setProperty("visibility", "hidden", "important");
      element.style.setProperty("opacity", "0", "important");
      element.style.setProperty("pointer-events", "none", "important");
      element.setAttribute("data-cdp-formilla-hidden", "true");
    });
  }

  function restoreFormilla() {
    document
      .querySelectorAll('[data-cdp-formilla-hidden="true"]')
      .forEach(function (element) {
        element.style.removeProperty("display");
        element.style.removeProperty("visibility");
        element.style.removeProperty("opacity");
        element.style.removeProperty("pointer-events");
        element.removeAttribute("data-cdp-formilla-hidden");
      });
  }

  function openConfigurator() {
    clearTimeout(closeTimer);

    configuratorOpen = true;
    document.documentElement.classList.add(ROOT_CLASS);

    forceHideFormilla();

    /*
     * Formilla or ShapeDiver may redraw after the click,
     * so repeat the hide operation during the opening animation.
     */
    window.setTimeout(forceHideFormilla, 50);
    window.setTimeout(forceHideFormilla, 250);
    window.setTimeout(forceHideFormilla, 750);
    window.setTimeout(forceHideFormilla, 1500);
  }

  function closeConfigurator() {
    clearTimeout(closeTimer);

    /*
     * Allow ShapeDiver's close animation to finish before restoring chat.
     */
    closeTimer = window.setTimeout(function () {
      configuratorOpen = false;
      document.documentElement.classList.remove(ROOT_CLASS);
      restoreFormilla();
    }, 250);
  }

  /**
   * Finds matching controls through normal DOM elements and
   * through composed event paths.
   */
  function pathContainsSelector(event, selector) {
    const path =
      typeof event.composedPath === "function"
        ? event.composedPath()
        : [];

    for (const item of path) {
      if (
        item instanceof Element &&
        typeof item.matches === "function" &&
        item.matches(selector)
      ) {
        return true;
      }
    }

    return (
      event.target instanceof Element &&
      event.target.closest(selector) !== null
    );
  }

  /**
   * Capture phase is intentional. ShapeDiver may stop click
   * propagation before a normal document listener receives it.
   */
  document.addEventListener(
    "click",
    function (event) {
      if (pathContainsSelector(event, OPEN_SELECTOR)) {
        openConfigurator();
        return;
      }

      if (pathContainsSelector(event, CLOSE_SELECTOR)) {
        closeConfigurator();
      }
    },
    true
  );

  /*
   * Keyboard users may activate the buttons with Enter or Space.
   */
  document.addEventListener(
    "keydown",
    function (event) {
      if (event.key !== "Enter" && event.key !== " ") {
        return;
      }

      if (pathContainsSelector(event, OPEN_SELECTOR)) {
        openConfigurator();
        return;
      }

      if (pathContainsSelector(event, CLOSE_SELECTOR)) {
        closeConfigurator();
      }
    },
    true
  );

  /**
   * Observe dynamically inserted cart items, app buttons,
   * ShapeDiver modals, and Formilla replacement elements.
   */
  function startObserver() {
    if (!document.body) {
      window.requestAnimationFrame(startObserver);
      return;
    }

    const observer = new MutationObserver(function () {
      if (observerQueued) {
        return;
      }

      observerQueued = true;

      window.requestAnimationFrame(function () {
        observerQueued = false;

        if (configuratorOpen) {
          forceHideFormilla();
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Safety reset for browser back/forward navigation.
   */
  window.addEventListener("pageshow", function () {
    if (!configuratorOpen) {
      document.documentElement.classList.remove(ROOT_CLASS);
      restoreFormilla();
    }
  });

  installStyles();
  startObserver();
})();